import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios'
import environment from '@/environment'
import api from '@/servicesTS/higia-api-provider.service'
import router from '@/router'
import keycloackService from '@/services/keycloak.service'
import HigiaAuthService from '@/servicesTS/HigiaAuthService'
import HigiaErrorSevice from 'higia-lib-components/src/lib-components/modules/higia-erro/services/higia-error-service'
import HigiaGtmService from 'higia-lib-components/src/lib-components/modules/higia-gtm/services/higia-gtm.service'
import DataLayer from 'higia-lib-components/src/lib-components/modules/higia-gtm/domains/data-layer.dto'
import Usuario from 'higia-lib-components/src/lib-components/domains/user.dto'
import ErrorHigia from 'higia-lib-components/src/lib-components/modules/higia-erro/domains/error-higia-dto'

export default class HigiaInterceptorService {
    CancelToken = axios.CancelToken
    cancel: any
    usuario = Usuario.getInstance()

    static currentRequestUrl = ''
    static currentUrl = ''

    /**
     * Instancia de Axios para conexão as API's
     */
    public readonly instance: AxiosInstance

    /**
     * Serviço para facilitar o tratamento de erros que vem do Axios.
     */
    higiaErrorSevice: HigiaErrorSevice
    higiaAuthService: HigiaAuthService

    dataLayer: DataLayer
    higiaGtmService: HigiaGtmService = new HigiaGtmService()

    errorHigia = new ErrorHigia(0, '', '', '', '', 0, '', '', '')

    public constructor() {
        console.log('Interceptor Login V(2.0.0)')
        this.dataLayer = new DataLayer('', '', '', '', '', '', '')
        this.instance = api.apiProvider
        this.higiaErrorSevice = new HigiaErrorSevice()
        this.higiaAuthService = new HigiaAuthService()
        this._verifyToken()
        this._initializeResponseInterceptor()
        this._initializeRequestInterceptor()
    }

    private _verifyToken() {
        if (window.location.pathname.indexOf('/homeHigia') > -1 && !localStorage.getItem('access_token')) {
            window.location.href = '/login'
        }
    }

    private _initializeResponseInterceptor = () => {
        this.instance.interceptors.response.use(this._handleResponse, this._handleError)
    }

    private _initializeRequestInterceptor = () => {
        this.instance.interceptors.request.use(this._handleRequest, this._handleError)
    }

    private _handleRequest = async (config: AxiosRequestConfig) => {
        if (config && config.url) {
            config.timeout = 100000
            HigiaInterceptorService.currentRequestUrl = config.url
            if (
                config.url.indexOf('/authenticate') > -1 ||
                config.url.indexOf('/viacep') > -1 ||
                config.url.indexOf(environment.blobStorageAzureApi || '') > -1 ||
                !router.currentRoute.meta?.requiresAuth
            ) {
                if (!router.currentRoute.meta?.requiresAuth) {
                    config.baseURL = environment.authApi
                }
                return config
            } else {
                return this._getConfigReq(config)
            }
        }
    }

    private _getConfigReq = (config: any) => {
        const token = keycloackService.getToken()
        config.baseURL = environment.api
        if (!config.headers['Content-Type']) config.headers['Content-Type'] = 'application/json'
        config.headers['Authorization'] = 'Bearer ' + token
        return config
    }

    private _handleResponse = (response: AxiosResponse) => {
        //Retornos com sucesso de tipo >=200 e < 400

        if (response && response.status >= 0 && response.status < 400) {
            return response
        } else {
            //Retornos de erro de cliente de tipo >=400 e < 500
            response.data = this.higiaErrorSevice.handleError(response)

            if (response && response.status >= 400 && response.status < 500) {
                // erro de falha de autenticação mostra pagina default com modal de erro
                if (response.status == 401) {
                    if (window.location.pathname.indexOf('/homeHigia') > -1) {
                        router.push('/homeHigia/errHigia')
                    } else if (window.location.pathname != '/' && window.location.pathname.indexOf('/login') <= -1) {
                        router.push('/errHigia')
                    }

                    /** Inicio GTM */
                    const tempoSecao: any = this.higiaAuthService.getSessionTime()
                    const conversaoMinutos: any = (tempoSecao / 60).toFixed(2)
                    this.usuario = Usuario.getInstance()
                    const dadosAdicionais = {
                        serviceUri: response.config ? response.config.url : '',
                    }
                    this.dataLayer = new DataLayer(
                        HigiaGtmService.EVENTS.AUTHENTICATION_ERROR,
                        this.usuario.login || '',
                        HigiaGtmService.TYPE.SERVICE,
                        '(401) - Erro de Autenticação /Sessão expirada : ' + conversaoMinutos + '(Minutos)',
                        HigiaGtmService.STATUS.ERROR,
                        document.location.pathname,
                        dadosAdicionais
                    )
                    this.higiaGtmService.setDataLayer(this.dataLayer)
                    /** Fim GTM */
                }

                return new Promise<AxiosResponse<any>>((_, reject) => {
                    reject(response)
                })
            } else {
                //Retornos de erro de servidor de tipo >=500  e < 600
                if (response && response.status >= 500 && response.status < 600) {
                    return new Promise<AxiosResponse<any>>((_, reject) => {
                        reject(response)
                    })
                } else {
                    //Caso seja gerado um erro sem status code
                    //TODO verificar o retorno para este cenario
                    return new Promise<AxiosResponse<any>>((_, reject) => {
                        reject(response)
                    })
                }
            }
        }
    }

    protected _handleError = (error: any) => {
        if (error) {
            const errorMessage: string = error.toString()
            if (errorMessage.indexOf('cancelToken') <= -1) {
                if (error.isAxiosError) {
                    return this._getNetworkError(error)
                } else {
                    if (window.location.pathname.indexOf('/errHigia') <= -1) {
                        HigiaErrorSevice.currentUrl = window.location.pathname
                    }
                    if (
                        HigiaInterceptorService.currentRequestUrl.indexOf('/authenticate') <= -1 &&
                        HigiaInterceptorService.currentRequestUrl.indexOf('/viacep') <= -1 &&
                        window.location.pathname.indexOf('/errHigia') <= -1
                    ) {
                        router.push('/homeHigia/errHigia?type=critico')
                    }
                }
            } else {
                console.log('_handleError:' + errorMessage)
            }
        }
    }

    _getNetworkError = (error: any) => {
        if (error.isAxiosError) {
            this.errorHigia.status = 0
            this.errorHigia.mensagemHg = 'Network Axios error'
            this.errorHigia.codTipoErroHg = 0
            this.errorHigia.descTipoErroHg = 'critico'
            this.errorHigia.path = window.location.pathname
            return new Promise<AxiosResponse<any>>((_, reject) => {
                reject({ data: this.errorHigia })
            })
        }
    }
}
